import {Experiment} from '../reducers/experiments';

export type RouteType = 'filter' | 'category';

export interface Route {
  label: string;
  labelForHeader?: string;
  path: string;
  tag: string;
  show: boolean;
  menuLevel?: number; // 1 = visible products list, 2 = dropdown list
  type?: RouteType;
}

export const allUpdates: Route = {label: 'navigation.all.updates', path: '/', tag: 'main', type: 'filter', show: true} ;
export const allUpdatesNew: Route = {label: 'navigation.all', labelForHeader: 'navigation.all.updates', path: '/', tag: 'main', type: 'filter', show: true};
const newFeatures: Route = {label: 'navigation.new.features', path: '/new-features', tag: 'new-features', type: 'filter', show: true};
const featureUpdates: Route = {label: 'navigation.features.updates', path: '/feature-updates', tag: 'feature-updates', type: 'filter', show: true};

export const filterCategories: Route[] = [
  allUpdates,
  newFeatures,
  featureUpdates,
  {label: 'navigation.bugs.fixes', path: '/bug-fixes', tag: 'bug-fixes', type: 'filter', show: true}
];

export const filterCategoriesNew: Route[] = [
  allUpdatesNew,
  newFeatures,
  {label: 'navigation.bug.fixes', path: '/bug-fixes', tag: 'bug-fixes', type: 'filter', show: true}
];

export const productsCategories: Route[] = [
  {label: 'navigation.wix.home', path: '/wix-home', tag: 'wix-home', type: 'category', show: true},
  {label: 'navigation.wix.editor', path: '/wix-editor', tag: 'wix-editor', type: 'category', show: true},
  {label: 'navigation.wix.adi', path: '/wix-adi', tag: 'wix-adi', type: 'category', show: true},
  {label: 'navigation.wix.stores', path: '/wix-stores', tag: 'wix-stores', type: 'category', show: true},
  {label: 'navigation.wix.mobile.app', path: '/wix-mobile-app', tag: 'wix-mobile-app', type: 'category', show: true},
  {label: 'navigation.wix.promote', path: '/wix-promote', tag: 'wix-promote', type: 'category', show: false},
  {label: 'navigation.wix.music', path: '/wix-music', tag: 'wix-music', type: 'category', show: false},
  {label: 'navigation.wix.restaurants', path: '/wix-restaurants', tag: 'wix-restaurants', type: 'category', show: false},
  {label: 'navigation.wix.photography', path: '/wix-photography', tag: 'wix-photography', type: 'category', show: false},
  {label: 'navigation.wix.forums', path: '/wix-forum', tag: 'wix-forum', type: 'category', show: false},
  {label: 'navigation.wix.video', path: '/wix-video', tag: 'wix-video', type: 'category', show: false},
  {label: 'navigation.wix.blog', path: '/wix-blog', tag: 'wix-blog', type: 'category', show: false},
  {label: 'navigation.wix.bookings', path: '/wix-bookings', tag: 'wix-bookings', type: 'category', show: false},
  {label: 'navigation.wix.hotels', path: '/wix-hotels', tag: 'wix-hotels', type: 'category', show: false},
  {label: 'navigation.wix.app.market', path: '/wix-app-market', tag: 'wix-app-market', type: 'category', show: false},
  {label: 'navigation.wix.invoices', path: '/wix-invoices', tag: 'wix-invoices', type: 'category', show: false},
  {label: 'navigation.wix.inbox', path: '/wix-inbox', tag: 'wix-inbox', type: 'category', show: false},
  {label: 'navigation.wix.pro.gallery', path: '/wix-pro-gallery', tag: 'wix-pro-gallery', type: 'category', show: false},
  {label: 'navigation.wix.events', path: '/wix-events', tag: 'wix-events', type: 'category', show: false},
  {label: 'navigation.wix.seo.wiz', path: '/wix-seo-tools', tag: 'wix-seo-tools', type: 'category', show: false},
  {label: 'navigation.wix.corvid', path: '/corvid', tag: 'corvid', type: 'category', show: false},
  {label: 'navigation.wix.velo', path: '/velo', tag: 'velo', type: 'category', show: false},
  {label: 'navigation.wix.logo', path: '/wix-logo', tag: 'wix-logo', type: 'category', show: false},
  {label: 'navigation.payments', path: '/payments', tag: 'payments', type: 'category', show: false},
];
export const filter = (experiments: Experiment[] = []) => {

  return filterCategoriesNew.slice(0);
};

export const products = (experiments: Experiment[] = []) => {
  const items = productsCategories.slice(0);

  return items.filter((cat) => cat.label !== 'navigation.wix.velo');
};
